import { userInfoSync } from 'hub-http/userInfo';
export function useIsUngated(gateName) {
  try {
    return userInfoSync().gates.includes(gateName);
  } catch (e) {
    return false;
  }
}